import { Controller } from "@hotwired/stimulus"

// Toggles the product image source between an uploaded file and a built-in
// stock image, showing only the chosen source's panel. Switching back to
// "upload" clears any stock selection so the upload is used; a chosen stock
// image otherwise takes precedence server-side.
export default class extends Controller {
  static targets = ["deleteCheckbox", "stockPanel", "stockRadio", "uploadPanel"]

  connect() {
    if (this.stockRadioTargets.some((radio) => radio.checked)) {
      this.showStock()
    } else {
      this.showUpload()
    }
  }

  selectSource(event) {
    if (event.target.value === "stock") {
      this.showStock()
    } else {
      this.showUpload()
    }
  }

  showStock() {
    this.uploadPanelTarget.classList.add("hidden")
    this.stockPanelTarget.classList.remove("hidden")
    if (this.hasDeleteCheckboxTarget) this.deleteCheckboxTarget.checked = false
  }

  showUpload() {
    if (this.hasStockPanelTarget) this.stockPanelTarget.classList.add("hidden")
    this.uploadPanelTarget.classList.remove("hidden")
    this.stockRadioTargets.forEach((radio) => (radio.checked = false))
  }
}
